module.exports = __webpack_public_path__ + "static/media/07.08.f16cb6a9.webp";